import { memo } from 'react';
import styles from '../../../../styles/automation/index.module.scss';

export const VariableDropdownItem = memo(({
    item,
    index,
    activeIndex,
    descriptions,
    onSelect,
    onMouseEnter,
}) => (
    <li
        key={item.id}
        onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSelect(item);
        }}
        onMouseEnter={() => onMouseEnter(index)}
        className={`${styles.dropdownItem} ${index === activeIndex ? styles.active : ''}`}
        tabIndex={0}
        aria-selected={index === activeIndex}
        onFocus={() => onMouseEnter(index)}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                onSelect(item);
            }
        }}
    >
        <span
            className={`${styles.variableIcon} ${descriptions[item.id]?.isSecret ? styles.secret : styles.normal}`}
            title={descriptions[item.id]?.systemVariable ? 'Project Variable' : 'Environment Variable'}
        >
            {descriptions[item.id]?.systemVariable ? 'P' : 'E'}
        </span>
        ${item.key}
    </li>
));

export const FileDropdownItem = memo(({
    item,
    index,
    activeIndex,
    onSelect,
    onMouseEnter,
}) => (
    <li
        key={item.id}
        onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSelect(item);
        }}
        onMouseEnter={() => onMouseEnter(index)}
        className={`${styles.dropdownItem} ${index === activeIndex ? styles.active : ''}`}
        tabIndex={0}
        aria-selected={index === activeIndex}
        onFocus={() => onMouseEnter(index)}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                onSelect(item);
            }
        }}
    >
        <span className={styles.fileItemIcon} title="File">
            F
        </span>
        {item.name}
    </li>
));
